/* Chumart 站内小补丁（全站加载，theme.liquid 引入）
   1) 分类/品牌 Hub 页里的 "See all N products →"：
      它的 href 就是当前合集自己（不带任何参数），点了等于刷新回顶部。
      改成平滑滚到下面的产品列表。
      只拦截 href 与当前路径完全相同、且不带 ?query / #hash 的链接。
      子分类卡里的链接很多是 "当前合集?filter.p.product_type=..."（同路径 + 筛选参数），
      那些必须照常跳转去筛选，不能拦。 */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    var hub = a.closest('.section-category-nav-hub, .cc-brand-hub, [class*="brand-hub"]');
    if (!hub) return;
    var raw = a.getAttribute('href') || '';
    if (raw.indexOf('?') !== -1 || raw.indexOf('#') !== -1) return;
    var grid = document.querySelector('.cc-collection-products, .main-products-grid');
    if (!grid) return;
    var here = location.pathname.replace(/\/$/, '');
    var to = raw.replace(/\/$/, '');
    if (to !== here) return;
    e.preventDefault();
    var y = grid.getBoundingClientRect().top + window.pageYOffset - 8;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });
})();

/* 2) 普通合集页横幅描述：手机端限行（CSS 在 cm-hub.css），这里做展开/收起。
      内容本来就不超过设定行数 → 加 cm-cdesc--fits 把按钮藏掉；转屏/改宽再算一次。 */
(function () {
  function fits(box) {
    var body = box.querySelector('.cm-cdesc__body');
    if (!body) return true;
    return body.scrollHeight <= body.clientHeight + 2;
  }
  function check() {
    var list = document.querySelectorAll('.cm-cdesc--clamp');
    for (var i = 0; i < list.length; i++) {
      var box = list[i];
      if (box.classList.contains('is-open')) continue;
      box.classList.toggle('cm-cdesc--fits', fits(box));
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cm-cdesc__more');
    if (!btn) return;
    var box = btn.closest('.cm-cdesc--clamp');
    if (!box) return;
    var open = !box.classList.contains('is-open');
    box.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? (btn.getAttribute('data-less') || 'Show less') : (btn.getAttribute('data-more') || 'Read more');
    if (!open) {
      var y = box.getBoundingClientRect().top;
      if (y < 0) window.scrollBy({ top: y - 16, behavior: 'smooth' });
    }
  });
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(check, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
  window.addEventListener('load', check);
  document.addEventListener('shopify:section:load', check);
})();
